import React from "react";
import { useState } from "react";
import "../../Workspace2/sidebar.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";
import InProgress from "../../../assets/Image/InProgress.png";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { useHistory, useParams } from "react-router-dom";
import { CreateWorkspace, getWorkspace } from "../ApiServices/apiHandler";
import WorkspaceHeader from "./WorkspaceHeader";
import swal from 'sweetalert';
import dayjs from 'dayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { useEffect } from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
// import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { createBookClosure } from "../../../Bookclosure/Services/ApiHandler";
import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
import { motion } from "framer-motion";

import { getActivePlan } from "../ApiServices/apiHandler";

import commoncss from "../../../myfin_v2/css/common.module.css"
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css"
import { ReactComponent as RightIcon } from "../../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as PervBtnIcon } from '../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import { ReactComponent as CalenderIcon } from '../../../myfin_v2/assets/icons/calender.svg'
import { ReactComponent as DataAnalyticsComingSoon } from '../../../myfin_v2/assets/icons/dataAnalyticsComingSoon.svg'
import { ReactComponent as ProjectionsComingSoon } from '../../../myfin_v2/assets/icons/projectionsComingSoon.svg'
import { ReactComponent as SEBIReportingComingSoon } from '../../../myfin_v2/assets/icons/sebiReportingComingSoon.svg'

import InputGroup from '../../../myfin_v2/elements/InputGroup'

const label = { inputProps: { "aria-label": "Checkbox demo" } };


const style = {
  position: "absolute",
  top: "75%",
  left: "36%",
  transform: "translate(-50%, -50%)",
  height: 250,
  width: 320,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

const GettingStarted = () => {
  const { workspaceId } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();

  const [activePlandata, setActiveplanData] = useState([]);
  const user = JSON.parse(localStorage.getItem('user'));
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorElConsole, setAnchorElConsole] = React.useState(null);
  const [checkstatus, setCheckStatus] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [isCheckedconsole, setIsCheckedConsole] = useState(false);
  const [yearData, setYearData] = useState({
    standalone_py: "",
    standalone_cy: "",
    console_py: "",
    console_cy: "",
    bookClosureAsOnDate: "",
  });
  const [hasWorkspace, setHasWorkspace] = useState(false);
  const [workspace, setWorkspace] = useState([]);

  const [isBookClosureOpen, setIsBookClosureOpen] = useState(false);
  const [isBookClosureCheckBox, setIsBookClosureCheckBox] = useState(false);

  const [isStandaloneFinCheckBox, setIsStandaloneFinCheckBox] = useState(false);

  const [isMouseOverBookClosure, setIsMouseOverBookClosure] = useState(false);
  const [isMouseOverStandAlone, setIsMouseOverStandAlone] = useState(false);
  const [isMouseOverConsolidate, setIsMouseOverConsolidate] = useState(false);

  const [selectedModules, setSelectedModules] = useState([]);

  const toggleModules = (item) => {
    setSelectedModules(prev => {
      if (prev.includes(item)) {
        return prev.filter(i => i !== item);
      } else {
        return [...prev, item];
      }
    });
  };

  const openConsole = Boolean(anchorElConsole);
  const id_c = openConsole ? "simple-popover" : undefined;
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  useEffect(() => {
    if (typeof workspaceId !== 'undefined' && workspaceId !== null) {
      getWorkspaceDetails(workspaceId);
    }
  }, [])

  const getWorkspaceDetails = async (w_id) => {
    const res = await getWorkspace(w_id);
    if (res.status === 200) {
      setHasWorkspace(true)
      setWorkspace(res.data.getworkspace[0])
    }
  }
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose2 = () => {
    setAnchorElConsole(null);
  };

  useEffect(() => {

    activePlan();

  }, [])



  const activePlan = async () => {
    try {
      const res = await getActivePlan();
      console.log(res.data.categorizedBenefits.workspaceFunctions, "res--------->");
      setActiveplanData(res.data.categorizedBenefits.workspaceFunctions);

    } catch (error) {
      console.log(error.message)
    }
  }


  // Function to handle checkbox click
  const handleCheckboxClick = (event) => {
    setIsChecked(event);
    setIsStandaloneFinCheckBox(event);
    if (event === false) {
      setAnchorEl(event);
      yearData.standalone_cy = "";
      yearData.standalone_py = "";
    }
  };
  const handleClickConsol = (event) => {
    if (isCheckedconsole === false) {
      setAnchorElConsole(event.currentTarget);
    }
    
  };
  /// 


  const handleYearChange = (field, e) => {
    setYearData({ ...yearData, [field]: dayjs(e).format('YYYY-MM-DD') });
    if (yearData.standalone_py && yearData.standalone_cy) {
      saveStandAloneRange()
    }
  };
  const saveStandAloneRange = () => {
    setAnchorEl(null);
    setCheckStatus(true);
    setHasWorkspace(false)
  };
  const handleSaveConsole = () => {
    setAnchorElConsole(null);
  };

  const SaveWorkspaceCompany = async () => {
    try {
      let data = {};
      if (typeof workspaceId !== 'undefined' && workspaceId !== null) {
        data = {
          workspaceId: workspaceId ? workspaceId : "",
          standalone_cy: workspace.standalone_cy,
          standalone_py: workspace.standalone_py,
          console_cy: workspace.console_cy,
          console_py: workspace.console_py,
          book_closure_as_on_date: workspace?.bookClosureAsOnDate,
          steps: "step1",
          has_published: "draft",
          status: workspace.status,
          selectedModules: selectedModules
        };
      } else {
        data = {
          workspaceId: workspaceId ? workspaceId : "",
          standalone_cy: yearData.standalone_cy,
          standalone_py: yearData.standalone_py,
          book_closure_as_on_date: yearData?.bookClosureAsOnDate || "",
          console_cy: isCheckedconsole ? yearData.standalone_cy : "",
          console_py: isCheckedconsole ? yearData.standalone_py : "",
          steps: "step1",
          has_published: "draft",
          status: "start",
          selectedModules: selectedModules
        };
      }

      const res = await CreateWorkspace(data);
      if (res.status === 200) {
        if (isBookClosureCheckBox) {
          createBookClosure({
            workspaceID: res.data.data._id,
            asOnDate: moment(yearData.bookClosureAsOnDate).format("DD-MM-YYYY"),
          }).then(response => {
            dispatch({ type: "BOOK_cLOSURE_DATA", payload: response.data?.bookClosure || {} });
            toast.success("Book Disclosure Created Successfully.")
          }).catch(error => {
            toast.error(`Book Disclosure Error: ${error}`)
          })
        }
        history.push(`/workspacesetup/${res.data.data._id}`);
      }
    } catch (error) {
      return 0;
    }
  };

  const handlecheck = () => {
    console.log(yearData, "----------")
    if (yearData.standalone_cy == '' || yearData.standalone_py == '') {
      swal({
        title: "Please select the",
        text: "Financial Statements Standalone",
        html: true,
        icon: 'warning',

      });
      return false
    }


  }

  const isCheckedNextBtn = () => !((isChecked && checkstatus) || isCheckedconsole || isBookClosureCheckBox || (typeof workspaceId !== "undefined" && workspaceId !== null));

  return (
    <>
      {/* <WorkspaceHeader
        currentStep="1"
        title="What are you currently working on ?"
      /> */}
      <motion.div initial={{ y: 500, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: 0, opacity: 0 }}
        transition={{ duration: 0.7, ease: "easeInOut" }} className={wsCreationcss.wsContentDiv}>
        <span className={`${wsCreationcss.wsContentHeading} mt-4`}>
          What are you currently working on?
        </span>
        <div className={`${wsCreationcss.modulesContainer} mt-4`}>
          <div className={wsCreationcss.modulesGrid}>
            {/* Book Closure */}
            {activePlandata.includes('Book Closure') ? (
              <div className={`${wsCreationcss.moduleCard} ${isBookClosureCheckBox ? wsCreationcss.cardActive : ''} pb-1 ${isMouseOverBookClosure ? wsCreationcss.cardHover : ''}`} onClick={() => {
                setIsBookClosureCheckBox(!isBookClosureCheckBox);
                setIsBookClosureOpen(!isBookClosureOpen);
                toggleModules("Book Closure");
              }}
                onMouseEnter={() => setIsMouseOverBookClosure(true)}
                onMouseLeave={() => setIsMouseOverBookClosure(false)}>
                <span className={wsCreationcss.moduleLabel}>Book Closure</span>
                {(isBookClosureOpen) && (
                  <>
                    <InputGroup
                      width="185px"
                      label="As of date"
                      inputs={[
                        <>
                          <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                              <div onClick={(e) => e.stopPropagation()}>
                                <MobileDatePicker
                                  className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                  // value={dayjs(addTaskForm.dueDate)}
                                  onChange={(e) => handleYearChange("bookClosureAsOnDate", e)}
                                  format="DD-MMM-YYYY"
                                  slotProps={{
                                    textField: {
                                      InputProps: {
                                        disableUnderline: true,
                                      },
                                      sx: {
                                        '& fieldset': {
                                          border: 'none',
                                        },
                                      },
                                    },
                                  }}
                                />
                              </div>
                            </DemoContainer>
                          </LocalizationProvider>
                          <span className="icon">
                            <CalenderIcon
                              className="vaMiddle"
                              width={20}
                              height={20}
                            />
                          </span>
                        </>,
                      ]}
                    />
                  </>
                )}
              </div>
            ) : (
              <div className={`${wsCreationcss.moduleCard} ${isBookClosureCheckBox ? wsCreationcss.cardActive : ''} pb-1`} >
                <span className={wsCreationcss.moduleLabel}>Book Closure</span>
              </div>
            )}
            {/*Standalone Financial Statements*/}
            {activePlandata.includes('Standalone financial statements') ? (
              <>
                <div
                  className={`${wsCreationcss.moduleCard} ${isStandaloneFinCheckBox
                    ? wsCreationcss.cardActive
                    : (hasWorkspace && workspace.standalone_cy) || isChecked
                      ? wsCreationcss.cardActive
                      : wsCreationcss.moduleCard
                    } pb-0 ${isMouseOverStandAlone ? wsCreationcss.cardHover : ''}`}
                  onClick={() => {
                    if (user.responsibilities === "approver" || workspace.status === "waiting") { } else { handleCheckboxClick(!isStandaloneFinCheckBox); toggleModules("Standalone"); }
                  }}

                  onMouseEnter={() => setIsMouseOverStandAlone(true)}
                  onMouseLeave={() => setIsMouseOverStandAlone(false)}
                >
                  <span className={wsCreationcss.moduleLabel}>Standalone Financial Statements</span>
                  {(isStandaloneFinCheckBox) && (
                    <InputGroup
                      inputs={[
                        <>
                          <InputGroup
                            label="Current Year"
                            width="100px"
                            group_width="120px"
                            inputs={[
                              <>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                    <div onClick={(e) => e.stopPropagation()}>
                                      <MobileDatePicker
                                        className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                        // value={dayjs(addTaskForm.dueDate)}
                                        onChange={(e) => handleYearChange("standalone_cy", e)}
                                        format="DD-MMM-YYYY"
                                        slotProps={{
                                          textField: {
                                            InputProps: {
                                              disableUnderline: true,
                                            }, sx: {
                                              width: '125px',
                                              '& fieldset': {
                                                border: 'none',
                                              },
                                              '& input::placeholder': {
                                                fontSize: '11px',
                                              },
                                            },
                                          },
                                        }}
                                      />
                                    </div>
                                  </DemoContainer>
                                </LocalizationProvider>
                                <span className="icon">
                                  <CalenderIcon
                                    className="vaMiddle"
                                    width={20}
                                    height={20}
                                  />
                                </span>
                              </>,
                            ]}
                          />

                        </>,
                        <>
                          <InputGroup
                            label="Previous Year"
                            width="100px"
                            group_width="120px"
                            inputs={[
                              <>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                  <DemoContainer components={["DatePicker", "MobileDatePicker"]}>
                                    <div onClick={(e) => e.stopPropagation()}>
                                      <MobileDatePicker
                                        className={`${commoncss.datePickerContainer} ${commoncss.clickable}`}
                                        // value={dayjs(addTaskForm.dueDate)}
                                        onChange={(e) => handleYearChange("standalone_py", e)}
                                        maxDate={dayjs(new Date(yearData.standalone_cy))}
                                        disabled={yearData.standalone_cy ? false : true}
                                        format="DD-MMM-YYYY"
                                        slotProps={{
                                          textField: {
                                            InputProps: {
                                              disableUnderline: true,
                                            }, sx: {
                                              width: '125px',
                                              '& fieldset': {
                                                border: 'none',
                                              },
                                              '& input::placeholder': {
                                                fontSize: '11px',
                                              },
                                            },
                                          },
                                        }}
                                      />
                                    </div>
                                  </DemoContainer>
                                </LocalizationProvider>
                                <span className="icon">
                                  <CalenderIcon
                                    className="vaMiddle"
                                    width={20}
                                    height={20}
                                  />
                                </span>
                              </>,
                            ]}
                          />
                        </>,
                      ]}
                    />
                  )}
                </div>
              </>

            ) : (
              <div
                className={`${wsCreationcss.moduleCard} ${isStandaloneFinCheckBox
                  ? wsCreationcss.cardActive
                  : (hasWorkspace && workspace.standalone_cy) || isChecked
                    ? wsCreationcss.cardActive
                    : wsCreationcss.moduleCard
                  }  pb-0 ${isMouseOverConsolidate ? wsCreationcss.cardHover : ''}`}
                onClick={() => {
                }}>
                <span className={wsCreationcss.moduleLabel}>Standalone Financial Statements</span>
              </div>
            )}


            {activePlandata.includes('Console financial statements') ? (
              <div
                className={`${wsCreationcss.moduleCard} ${isCheckedconsole
                  ? wsCreationcss.cardActive : wsCreationcss.moduleCard
                  } pb-0`}
                onClick={() => {
                  console.log("check consol");
                  
                    if (user.responsibilities === "approver" || workspace.status === "waiting") { } else {  toggleModules("Console");
                      handlecheck();setIsCheckedConsole(!isCheckedconsole);
                     }
                  }}


                onMouseEnter={() => setIsMouseOverConsolidate(true)}
                onMouseLeave={() => setIsMouseOverConsolidate(false)}
              >
                <span className={wsCreationcss.moduleLabel}>Consolidated Financial Statements</span>
              </div>
              // <div >
              //   <Card
              //     className={`${isCheckedconsole ? "card-v2-border" : hasWorkspace && workspace.console_cy ? "card-v2-border" : "card-v2"}`}>
              //     <CardContent>
              //       <Checkbox
              //         checked={hasWorkspace && workspace.console_cy ? true : isCheckedconsole}
              //         disabled={user.responsibilities === "approver" || workspace.status === "waiting"}
              //         onClick={(e) => handlecheck(e)}
              //         sx={{
              //           color: "#03565A",
              //           '&.Mui-checked': {
              //             color: "#03565A",
              //           },
              //         }}
              //       />
              //       <div className="chekbox-v2">
              //         Financial Statements
              //         <br />
              //         Consol
              //       </div>

              //       <div className="d-flex flex-column ml-2" style={{ color: "darkgray" }}>
              //         <div className="font-inter" style={{ fontSize: "12px" }}>
              //           <span className="font-inter" style={{ color: "darkgray", fontSize: "12px" }}>CY: </span>
              //           {isCheckedconsole === true
              //             ? moment(yearData.standalone_cy).format("MMMM DD, YYYY")
              //             : ""}
              //           {hasWorkspace && workspace.console_cy != "" ? (
              //             <span>{moment(workspace?.console_cy).format("MMMM DD, YYYY")}</span>
              //           ) : ""}
              //         </div>
              //         <div className="font-inter" style={{ fontSize: "12px" }}>
              //           <span className="font-inter" style={{ color: "darkgray", fontSize: "12px" }}>PY: </span>
              //           {isCheckedconsole === true
              //             ? moment(yearData.standalone_py).format("MMMM DD, YYYY")
              //             : ""}
              //           {hasWorkspace && workspace.console_py != "" ? (
              //             <span>{moment(workspace?.console_py).format("MMMM DD, YYYY")}</span>
              //           ) : ""}
              //         </div>
              //       </div>
              //     </CardContent>
              //   </Card>

              //   <Popover
              //     id={id_c}
              //     open={openConsole}
              //     anchorEl={anchorElConsole}
              //     onClose={handleClose2}
              //     anchorOrigin={{
              //       vertical: "bottom",
              //       horizontal: "center",
              //     }}
              //     transformOrigin={{
              //       vertical: "top",
              //       horizontal: "center",
              //     }}
              //   >
              //     <Typography sx={{ p: 2 }}>
              //       <div>
              //         <div>
              //           Select Current Year <span style={{ color: "red" }}>*</span>
              //         </div>
              //         <div>
              //           <input
              //             className="date-v2"
              //             type="date"
              //             onChange={(e) => handleYearChange("console_cy", e)}
              //           />
              //         </div>
              //         <div>
              //           Select Previous Year <span style={{ color: "red" }}>*</span>
              //         </div>
              //         <div>
              //           <input
              //             className="date-v2"
              //             type="date"
              //             onChange={(e) => handleYearChange("console_py", e)}
              //           />
              //         </div>

              //         <div style={{ marginTop: "30px" }}>
              //           <Button
              //             className="datebtn"
              //             style={{
              //               backgroundColor: "#03565A",
              //               color: "white",
              //               textTransform: "none",
              //             }}
              //             onClick={handleSaveConsole}
              //           >
              //             Save Range
              //           </Button>
              //         </div>
              //       </div>
              //     </Typography>
              //   </Popover>
              // </div>
            ) : (
              <div
                className={`${wsCreationcss.moduleCard} ${isStandaloneFinCheckBox
                  ? wsCreationcss.cardActive
                  : (hasWorkspace && workspace.standalone_cy) || isChecked
                    ? wsCreationcss.cardActive
                    : wsCreationcss.moduleCard
                  } pb-0`}
                onClick={() => { }}>
                <span className={wsCreationcss.moduleLabel}>Consolidated Financial Statements</span>
              </div>
              // <div >
              //   <Card className="card-v2">
              //     <CardContent>
              //       <Checkbox
              //         checked={false}
              //         disabled
              //         sx={{
              //           color: "#03565A",
              //           '&.Mui-checked': {
              //             color: "#03565A",
              //           },
              //         }}
              //       />
              //       <div className="chekbox-v2">
              //         Financial Statements
              //         <br />
              //         Consol
              //       </div>

              //       <div className="d-flex flex-column ml-2" style={{ color: "darkgray" }}>
              //         <div className="font-inter" style={{ fontSize: "12px" }}>
              //           <span className="font-inter" style={{ color: "darkgray", fontSize: "12px" }}>CY: N/A</span>
              //         </div>
              //         <div className="font-inter" style={{ fontSize: "12px" }}>
              //           <span className="font-inter" style={{ color: "darkgray", fontSize: "12px" }}>PY: N/A</span>
              //         </div>
              //       </div>
              //     </CardContent>
              //   </Card>
              // </div>
            )}

            {activePlandata.includes('Data analytics') ? (
              <DataAnalyticsComingSoon width={320} height={160} />
            ) : (
              <DataAnalyticsComingSoon />
            )}

            {activePlandata.includes('Projections (Budget vs fixed)') ? (
              <ProjectionsComingSoon width={320} height={160} />
            ) : (
              <ProjectionsComingSoon width={320} height={160} />

            )}

            {activePlandata.includes('SEBI Reporting') ? (
              <SEBIReportingComingSoon width={320} height={160} />
            ) : (
              <SEBIReportingComingSoon width={320} height={160} />
            )}

          </div>
        </div>
      </motion.div>
      <div className={wsCreationcss.footerContainer}>
        <div>
          <button
            onClick={() => history.push(`/dashboard`)}
            className={wsCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
        </div>
        <div className={wsCreationcss.footerbtnContainer}>
          {/* <button
            className={wsCreationcss.perviewBtn} type="button" style={{ "padding": "7px" }} onClick={() => history.push(`/dashboard`)}><PervBtnIcon height={19} />Previous</button> */}
          <button onClick={SaveWorkspaceCompany} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }} disabled={isCheckedNextBtn()}>Next<RightIcon height={12} /></button>

        </div>
      </div>
    </>
  );
};


export default GettingStarted;
